import * as React from "react";

import { withTheme } from "styled-components";
import { IconName, getNamedIcon } from "common/named-icons";
import { BuilderTheme } from "sharedUI/styles";

class ThemedIconInner extends React.PureComponent<{ icon: IconName; theme: BuilderTheme }> {
    public render(): React.ReactNode {
        const { theme, icon } = this.props;
        const Icon = getNamedIcon(icon);
        return <Icon fgColor={theme.dropdown.iconFg} />;
    }
}

export const ThemedIcon = withTheme(ThemedIconInner);
